import React from 'react'
import ActionModal from 'frontend/components/action-modal'
import PropTypes from 'prop-types'
import CommonIcons from 'frontend/components/common-icons'

function AddedToCartModal ({ room, time, onGoToCheckout, onAddAnotherRoom, onClose }) {
  return (
    <ActionModal
      body={
        <div>
          <div className="icon_place">
            <CommonIcons item="common-check-circle-r" className="icon" width={40} height={40} />
          </div>
          <p>
            You have added {room.name} on {time.format('MMMM D')} at{' '}
            {time.format(room.online ? 'h:mm a z' : 'h:mm a')} to your Adventure Pack.
          </p>
        </div>
      }
      className="slot_action_modal added_to_cart_modal"
      leftButton={
        <button className="left" onClick={onAddAnotherRoom}>
          <CommonIcons item="common-plus-circle" className="icon" width={16} height={16} />
          Another Game
          <span className="savings_label">Save $10</span>
        </button>
      }
      rightButtonLabel="Checkout"
      onRightClick={onGoToCheckout}
      onClose={onClose}
      showCloseButton={true}
    />
  )
}

AddedToCartModal.propTypes = {
  onAddAnotherRoom: PropTypes.func.isRequired,
  onGoToCheckout: PropTypes.func.isRequired,
  room: PropTypes.object.isRequired,
  time: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired
}

export default AddedToCartModal
